<template>
  <content-dialog
    :visible.sync="modalVisible"
    :max-width="previewMaxWidth"
  >
    <img
      v-if="image"
      :src="image"
      :style="{ maxWidth: previewMaxWidth + 'px' }"
      class="elevation-1"
      @load="getWidth"
    >
  </content-dialog>
</template>

<script>
    import ContentDialog from '@/components/helpers/Dialog'

    export default {
      name: 'PreviewImageDialog',
      components: {
        ContentDialog
      },
      data() {
        return {
          windowHeight: 0,
          windowWidth: 0,
          imageWidth: null
        }
      },
      computed: {
        modalVisible: {
          get: function () {
            return this.$store.state.ui.preview.image
          },
          set: function (value) {
            if (!value) this.$store.dispatch('closePreview')
          }
        },
        image: function () {
          return this.$store.state.ui.preview.file
        },
        previewMaxWidth: function () {
          if (!this.imageWidth) return 1200

          if (this.$vuetify.breakpoint.xsOnly) return this.windowWidth - 10

          return this.imageWidth > 1200 ? 1200 : this.imageWidth
        }
      },
      mounted() {
        this.onResize()
      },
      methods: {
        onResize() {
          this.windowHeight = window.innerHeight
          this.windowWidth = window.innerWidth
        },
        getWidth(event) {
          this.imageWidth = event.target.naturalWidth
        }
      }
    }
</script>
